<template>
  <div class="row">
    <div class="col-sm-12">
      <div class="dashboard-box team-member">
        <h2>{{ fullName }}</h2>

        <div v-if="editable" class="actions">
          <a href @click.prevent><i class="ion ion-drag"></i></a>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p class="dashboard-label">
              First name
            </p>
          </div>
          <div class="col-md-9">
            <p v-if="!editable" class="dashboard-value">
              {{ member.first_name }}
            </p>
            <input
              v-if="editable"
              class="form-control overview-input"
              :value="member.first_name"
              @blur="updateField('first_name', $event.target.value)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p class="dashboard-label">
              Last name
            </p>
          </div>
          <div class="col-md-9">
            <p v-if="!editable" class="dashboard-value">
              {{ member.last_name }}
            </p>
            <input
              v-if="editable"
              class="form-control overview-input"
              :value="member.last_name"
              @blur="updateField('last_name', $event.target.value)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p class="dashboard-label">
              Title
            </p>
          </div>
          <div class="col-md-9">
            <p v-if="!editable" class="dashboard-value">
              {{ member.title }}
            </p>
            <input
              v-if="editable"
              class="form-control overview-input"
              :value="member.title"
              @blur="updateField('title', $event.target.value)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p class="dashboard-label">
              E-mail
            </p>
          </div>
          <div class="col-md-9">
            <p v-if="!editable" class="dashboard-value">
              <CopyClick :text="member.email">
                {{ member.email }}
              </CopyClick>
            </p>
            <input
              v-if="editable"
              class="form-control overview-input"
              :value="member.email"
              @blur="updateField('email', $event.target.value)"
            />
          </div>
        </div>

        <div class="row">
          <div class="col-md-3">
            <p class="dashboard-label">
              Linkedin
            </p>
          </div>
          <div class="col-md-9">
            <p v-if="!editable" class="dashboard-value">
              <a v-if="member.linkedin" :href="member.linkedin" target="_new">
                {{ member.linkedin }}
              </a>
            </p>
            <input
              v-if="editable"
              class="form-control overview-input"
              :value="member.linkedin"
              @blur="updateField('linkedin', $event.target.value)"
            />
          </div>
        </div>

        <div v-show="editable" class="row">
          <div class="col-sm-12">
            <button
              class="btn btn-danger btn-xs btn-transparent"
              @click="deleteMember()"
            >
              Remove member
            </button>
          </div>
        </div>

        <ConfirmModal
          ref="confirmMemberDeletionModal"
          confirm-text="Remove"
          @confirm="confirmedMemberDeletion"
        >
          <h4 slot="modal-header" class="modal-title text-danger">
            Remove member
          </h4>
          <div slot="modal-body">
            <p>Are you sure you want to remove "{{ fullName }}"?</p>
          </div>
        </ConfirmModal>
      </div>
    </div>
  </div>
</template>

<script>
import CopyClick from 'components/CopyClick.vue'

export default {
  components: { CopyClick },
  props: {
    member: {
      type: Object,
      default: () => ({}),
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    fullName() {
      const names = [this.member.first_name, this.member.last_name].filter(
        (name) => name.length > 0,
      )
      return names.join(' ')
    },
  },
  methods: {
    updateField(field, value) {
      const changed = this.member[field] !== value
      if (!changed) return

      const data = { ...this.member, ...{ [field]: value } }
      this.$emit('member-updated', data)
      console.log(' => member-update:', data)
    },

    deleteMember() {
      this.$refs.confirmMemberDeletionModal.open()
    },

    confirmedMemberDeletion() {
      this.$refs.confirmMemberDeletionModal.close()
      const self = this
      setTimeout(function () {
        self.$emit('member-deleted', self.member)
      }, 200)
    },
  },
}
</script>

<style lang="scss" scoped>
@import '~assets/css/colors.scss';

.team-member {
  position: relative;

  .form-control {
    background-color: transparent;
  }

  .actions {
    position: absolute;
    top: 10px;
    right: 10px;
  }
}

.sortable-ghost {
  .team-member {
    background-color: $grey160;
  }
}
</style>
